import { settings } from '../../../settings/settings-util'
import Renderer from './renderers/renderer'
import Mutator from './renderers/mutator'
import * as Actions from './actions/actions'
import reducer from './reducers/index'
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';

const reduceReducers = (reducers) =>
{
    return (previous, current) =>
        reducers.reduce(
            (p,r) => r(p, current), previous
        );
};

export default class LaunchWindow
{
    constructor(passedSettings, mutatorModules = [], childComponents = [])
    {
        this._settings = passedSettings || settings;
        this._renderer = new Renderer(this._settings);
        this._mutator = new Mutator(this._settings);
        this._mutatorModules = mutatorModules;
        this._childComponents = childComponents;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        let reducers = [];

        reducers.push(reducer);

        this._childComponents.forEach((item) => {
            reducers.push(item.getReducer());
        });

        return reduceReducers(reducers);
    }

    getRenderer()
    {
        return this._renderer.getRender();
    }

    getMutator()
    {
        return this._mutator.getMutate();
    }

    initialize(store)
    {
        this._store = store;
        this.setupGlobal();
        this._mutators = [];
        this._childRenderers = [];

        this._mutatorModules.forEach((item) => {
            this._mutators.push(item.getMutator());
        });

        this._childComponents.forEach((item) => {
            this._childRenderers.push(item.getRenderer());
        });

        this._renderer.initialize(store, this._mutators, this._childRenderers);
        this._mutator.initialize(store);
    }

    setupGlobal()
    {
        let setupGlobal = this._settings.launchPoint.setupGlobal;
        if(!setupGlobal) return;

        let globalName = this._settings.launchPoint.globalFunctionName;
        if(!globalName) return;

        let stateLocation = this._settings.stateLocations.Window.IsMinimized;

        window[globalName] = () => {
            if(this._settings.stateLocations.Window.IsBlocked && this._store.getState()[this._settings.stateLocations.Window.Base][this._settings.stateLocations.Window.IsBlocked]) return;
            this._store.dispatch(Actions.restoreAlmeWindow(stateLocation));
            const input = {
                eventName: 'LaunchPointClicked',
                eventValue: "Global",
                messageType: this._settings.messageConstants.reportingEventRequest,
            };
            sendRequest(input);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-launch/src/window-launch.js